import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSun, FiCloud, FiCloudRain, FiDroplet, FiThermometer } = FiIcons;

const RegionalWeather = ({ data }) => {
  const regions = [
    {
      name: 'Northern Luzon',
      key: 'northern_luzon',
      icon: FiSun,
      color: 'bg-yellow-50 border-yellow-200 text-yellow-800'
    },
    {
      name: 'NCR & Central Luzon',
      key: 'ncr_central_luzon',
      icon: FiCloud,
      color: 'bg-blue-50 border-blue-200 text-blue-800'
    },
    {
      name: 'Southern Luzon',
      key: 'southern_luzon',
      icon: FiCloudRain,
      color: 'bg-gray-50 border-gray-200 text-gray-800'
    },
    {
      name: 'Visayas',
      key: 'visayas',
      icon: FiDroplet,
      color: 'bg-indigo-50 border-indigo-200 text-indigo-800'
    },
    {
      name: 'Mindanao',
      key: 'mindanao',
      icon: FiThermometer,
      color: 'bg-green-50 border-green-200 text-green-800'
    }
  ];

  const defaultRegionData = {
    condition: 'Partly cloudy',
    temperature: '28-32°C',
    rainfall: 'Isolated thunderstorms',
    notes: 'Monitor local weather updates'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="bg-white rounded-xl shadow-lg p-6 border border-blue-100"
    >
      <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
        <SafeIcon icon={FiCloud} className="mr-2 text-blue-600" />
        Regional Weather Summary
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {regions.map((region, index) => {
          const regionData = data?.[region.key] || defaultRegionData;
          
          return (
            <motion.div
              key={region.key}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.1 * index }}
              className={`p-4 rounded-lg border ${region.color}`}
            >
              <div className="flex items-center mb-2">
                <SafeIcon icon={region.icon} className="mr-2 text-lg" />
                <h3 className="font-semibold text-sm">{region.name}</h3>
              </div>
              
              <div className="space-y-1 text-xs">
                <p><strong>Condition:</strong> {regionData.condition}</p>
                <p><strong>Temperature:</strong> {regionData.temperature}</p>
                <p><strong>Rainfall:</strong> {regionData.rainfall}</p>
                {regionData.notes && (
                  <p className="text-gray-600 italic">{regionData.notes}</p>
                )}
              </div>
            </motion.div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default RegionalWeather;